<template>
    <div class="container containerManage ml10 mr10">
        <div class="top mt20">
            <div class="flex between ml10 mr10">
            <div class="flex center-row">
            
                <div class="flex center-row">
                    <div class=" flex center-row">
                    <span class="fz14 c6"> {{$t('manipulation.devName')}}：</span>
                    <el-input v-model="proname" :placeholder="$t('userManage.pleInputProName')"  style="width:170px"></el-input>    
                    <span class="fz14  ml20 c6">{{$t('userManage.account')}} ：</span>
                    <el-input v-model="iphoneval" :placeholder="$t('login.username')"  style="width:170px"></el-input> 
                     
                   
                </div>
                    <el-button type="primary" size="small" class="ml10" icon="el-icon-search" @click="search()">{{$t('tagsView.search')}}</el-button>
                    <el-button type="primary" size="small" class="ml10" icon="el-icon-refresh" @click="refresh()">{{$t('dataAnalysis.reset')}}</el-button>
                </div>
                </div>
                <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" v-if="permission.sys_user_add" @click="handleAdd">{{$t('userManage.newAdd')}}</el-button>
            </div>
            <!-- <el-form ref="form" :model="seachform" label-width="80px">
                <el-row type="flex" justify="space-between">
                    <el-col :span="4">
                        <el-form-item label="手机号">
                            <el-input v-model="seachform.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                         <el-form-item label="项目名称">
                            <el-input v-model="seachform.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1"></el-col>
                    <el-col :span="4">
                        <el-button type="primary" size="small" icon="el-icon-circle-plus-outline"  @click="handleAdd">新增</el-button>
                        <el-button type="primary" size="small" icon="el-icon-circle-plus-outline"  @click="handleAdd">新增</el-button>
                        

                    </el-col>
                </el-row>
                
                
            </el-form> -->
        </div>
        <div class="contentBox mt20">
            <el-table :data="tableData" border style="width: 100%"
             :row-class-name="getRowClass" 
              v-loading="loading" 
              :span-method="objectSpanMethod"
               @expand-change='expandHandle'>
                <!-- <el-table-column type="expand" >
                    <template slot-scope="props" >
                        <el-table stripe border style="width: 100%" :data="props.row.children" 
                         >
                        
                        <el-table-column v-for="(item, index) in columnlist3" :key="index" :prop="item.prop" :label="item.label"
                            align="center"></el-table-column>
                        
                        </el-table>
                    </template>
                </el-table-column> -->
                <el-table-column
                    v-for="(item, index) in columnlist"
                    :key="index"
                    :prop="item.prop"
                    :width="item.width"
                    :label="item.label"
                    align="center"
                    :default-sort="{ prop: 'userId', order: 'ascending' }"
                >
                </el-table-column>
             
                <el-table-column :label="$t('realdetile.opera')" align="center" width="290">
                    <!-- v-if="sys_user_add"  v-if="sys_user_edit" v-if="sys_user_del" v-if="sys_user_distribute" -->
                    <template slot-scope="scope">
                        <el-button type="text" plain size="small" icon="el-icon-edit" v-if="permission.sys_user_edit" @click="handleEdit(scope.$index, scope.row)" >{{$t('roleManage.revise')}}</el-button>
                        <el-button type="text" plain size="small" icon="el-icon-delete" v-if="permission.sys_user_del" @click="handleDel(scope.$index, scope.row)">{{$t('alarmSetting.delete')}}</el-button>
                        <el-button type="text" plain size="small" icon="el-icon-files" v-if="permission.sys_user_allot" @click="handleStation(scope.$index, scope.row)" >{{$t('userManage.assignItem')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page txtr mt10">
            <el-pagination
                background
                :current-page.sync="page.current"
                @current-change="handleCurrentChange"
                layout="total, prev, pager, next"
                :total="page.total"
            >
            </el-pagination>
        </div>
       
        <el-dialog
            class="userForm"
            :title="form.title"
            :visible.sync="dialogFormVisible"
            :before-close="handleCancel"
            width="600px"
            center
        >
            <el-form id="custom-form" class="flex" :model="form.formItem" :rules="form.rules" ref="ruleForm" label-width="120px">
                <el-form-item :label="$t('userManage.userName')" prop="account">
                    <el-input v-model="form.formItem.account" placeholder=""></el-input>
                </el-form-item>
                <el-form-item :label="$t('userManage.password')" prop="password">
                    <el-input v-model="form.formItem.password" placeholder="******"></el-input>
                </el-form-item>
                <el-form-item :label="$t('userManage.phoneNum')" prop="phone">
                    <el-input v-model="form.formItem.phone" placeholder=""></el-input>
                </el-form-item>
                <!-- <el-form-item label="公司名称" prop="realName">
                    <el-input v-model="form.formItem.realName" placeholder=""></el-input>
                </el-form-item> -->
                <el-form-item :label="$t('userManage.roleName')" prop="roleId">
                    <!-- <el-select v-model="form.roleId" @change="changesel" placeholder="请分配角色">
                        <el-option v-for="item in form.options" :key="item.id" :label="item.roleName" :value="item.id"> </el-option>
                       

                    </el-select>
                     <el-cascader :options="form.options" :props="prop" :show-all-levels="false"></el-cascader> -->
                     <Selecttree 
                        :props="prop"
                        :options="form.options"
                        :value="form.roleId"
                        :clearable="isClearable"
                        :accordion="isAccordion"
                        @getValue="getValue($event)"
                     />
                </el-form-item>
                 <el-form-item :label="$t('userManage.ifActivation')" prop="status" v-if="isshow">
                     <el-checkbox v-model="form.formItem.status" :true-label="1" :false-label="0"></el-checkbox>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="buttoncancel" size="small" @click="handleClose">{{$t('manipulation.cancel')}}</el-button>
                <el-button type="primary" size="small" @click="handleSubmit">{{$t('manipulation.sure')}}</el-button>
            </div>
        </el-dialog>
        <stationModal
            ref="stationModal"
            :title="station.title"
            :dialogStationVisible="station.dialogStationVisible"
            @closeStation="handleStationClose"
        ></stationModal>
    </div>
</template>

<script>
import { fetchList, addObj, putObj, delObj,putAlarmPush } from '@/api/admin/user';
import { deptRoleList,fetchroleList } from '@/api/admin/role';
import { getAllMenu, getRoleMenu, setRoleMenu } from '@/api/admin/role';
import Selecttree from '@/components/treeSelect'
import moment from 'moment'
import { mapGetters } from 'vuex';
import website from '@/config/website';

import {
  getStore
} from '@/util/store'
export default {
    name: 'userManage',
    components: {
        // userForm: () => import('./userForm'),
        stationModal: () => import('./stationModal'),
        Selecttree
    },
    data() {
        return {
            iphoneval:'',
            proname:'',
            seachform:{

            },
            test:false,
            param: {
                page: {
                    current: 1,
                    size: 10
                },
                roleId: '',
                menuIds: []
            },
             columnlist3: [{ prop: 'account', label: this.$t('userManage.userName') },
                { prop: 'phone', label: this.$t('userManage.phoneNum') },
                // { prop: 'realName', label: '公司名称' },
                // { prop: 'roleName', label: '角色名称' }
                ],
            loading: false,
            tableData: [],
            tableAlarmFlag: [],
            columnlist: Object.freeze([
                { prop: 'index', label: this.$t('realdetile.serNum'),width:100 },
               
                { prop: 'projectName', label: this.$t('manipulation.devName') },
                { prop: 'phone', label: this.$t('userManage.account') },
                 { prop: 'account', label: this.$t('userManage.operatorName') },
                // { prop: 'company', label: '公司名称' },
                { prop: 'roleName', label:  this.$t('userManage.operaPermission') }
                // { prop: 'depName', label: '管理电站' }
            ]),
            page: {
                current: 1,
                size: 5,
                total: 0,
                pages: 1
            },
            dialogFormVisible: false,
            form: {
                
                title: '',
                formItem: {
                    // userId: '',
                    account: '',
                    tenantId: this.$store.getters.tenantId,
                    deptId:'1315491184663224321',
                    password: '',
                    phone: '',
                    // realName: '',
                    roleId: '', // 整数roleId数组
                },
                roleId: '', // 显示roleName，实际传roleId的数组（只有一个值）
                options: [],
                rules: Object.freeze({
                    account: [{ required: true, message: this.$t('userManage.addAccountName'), trigger: 'blur' }],
                    password: [{ required: false, message: this.$t('userManage.addPassword'), trigger: 'blur' }],
                    phone: [{ required: true, message: this.$t('userManage.addPhone'), trigger: 'blur' },{pattern:/^(?:(?:\+|00)86)?1[3-9]\d{9}$/,message:this.$t('userManage.phoneFault')}],
                    // realName: [{ required: true, message: '请添加公司名称', trigger: 'blur' }],
                    roleId: [{ required: false, message: this.$t('userManage.addRole'), trigger: 'blur' }],
                })
            },
            auth: {
                dialogStationVisible: false,
                menuData: [],
                activeMenuData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            },
            station: {
                title: this.$t('userManage.assignItem'),
                dialogStationVisible: false,
                userId: NaN
            },
            isshow:false,
            prop:{
                value:'id',
                label:'title'
            },
            isClearable: true, // 可清空（可选）
            isAccordion: true, // 可收起（可选）
            rolelist:[]
        };
    },
    created() {
        this.getUserData();
        this.getRoleList();
        this.getfetchroleList()
    },
    computed: {
        ...mapGetters(['permission'])
    },
    mounted() {
        // console.log(moment("20211226").startOf('day').fromNow())
       
    },
    methods: {
        search(){
            this.param.page.current = 1
            this.getUserData()
        },
        refresh(){
            this.param.page.current = 1
            this.proname = ""
            this.iphoneval = ""
            this.getUserData()
        },
         objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let that = this
            that.spanArr = [] 
            that.pos = 0
            let data = this.tableData
        　　　　//遍历数据
            data.forEach((item, index) => {
                if (index === 0) {
                    this.spanArr.push(1)
                    this.pos = 0
                } else {
                    if (data[index].projectName&&data[index].projectName === data[index - 1].projectName) {
                        this.spanArr[this.pos] += 1
                        this.spanArr.push(0)
                    } else {
                        this.spanArr.push(1)
                        this.pos = index
                    }
                }
            })
            if (columnIndex === 1) {
                const _row = this.spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            } else {
                return false
            }
        },
        getfetchroleList(){
            fetchroleList({size:200}).then(res=>{
                 res = res.data.data;
                this.rolelist = res.records;
            })
             
        },
        getValue(e){
          
            this.form.roleId = e
            this.changesel(e)
        },
        // 表格详情没有内容隐藏箭头
        getRowClass(row) {
          
            if(!row.row.children || !row.row.children.length){ // 即该行没有子元素时，添加row-expand-cover类
                return 'row-expand-cover'
            }
        },
        
        expandHandle:async function (row,data) {
            console.log(row,data[0])
        
        },
        // 获取用户数据
        getUserData() {
            this.loading = true;
            fetchList({...this.param.page,phone:this.iphoneval,projectName:this.proname}).then(res => {
              
                res = res.data.data;
                res.records.map((item,index)=>{
                    item.index = index + 1
                })
                this.tableData = res.records;
                
                this.loading = false;
                const { total, pages, current, size } = res;
                this.page = { total, pages, current, size };
            });
        },
        getRoleList() {
            deptRoleList().then(res => {
                res = res.data.data;
                this.form.options = res;
            });
        },
        changesel(val){
          
            let res= this.rolelist.filter(v=>v.id===val)
            if(res.length>0&&res[0].isActivate){
                this.isshow = true
            }else{
                this.isshow = false
            }
        },
        // 分页导航
        handleCurrentChange(val) {
            this.param.page.current = val;
            this.getUserData();
        },
        // 新增用户的表单
        handleAdd() {
            
            this.form.roleId = '';
            this.form.title = this.$t('userManage.addUser');
            this.dialogFormVisible = true;
            this.form.formItem = {
                account: '',
                tenantId: this.$store.getters.tenantId,
                deptId:'1315491184663224321',
                password: '',
                phone: '',
                // realName: '',
                roleId: '', // 整数roleId数组
            }
        },
        // handleBtn(index, row) {
        //     const {id,alarmPushFlag } = row;
        //     let obj = { userId:id,alarmPushFlag };
        //     putAlarmPush(obj).then(res => {
        //         if (res.data.code === 200) {
        //             this.$message.success(`修改成功`);
        //             this.form.formItem = {};
        //             // this.getUserData();
        //         } else {
        //             this.$message.error('修改失败，请稍后重试');
        //             this.form.formItem = {};
        //         }
        //     });
        // },
        // 修改用户的表单
        handleEdit(index, row) {
            this.form.title = this.$t('userManage.chaAccount');

         
            const { account, password, phone, id,roleId,status,isActivate } = row;
            if(isActivate){
                this.isshow = true
            }
            this.form.formItem = { account, phone, id,roleId, password,status,isActivate,
                deptId:'1315491184663224321' };
            
            this.form.roleId = roleId
            this.dialogFormVisible = true;
        },
        // 提交表单
        handleSubmit() {
         
            this.form.formItem.roleId = this.form.roleId;
            if(this.form.formItem.password&&this.form.formItem.password.length<6){
                this.$message.error(this.$t('userManage.passLess'))
                return
            }
            if (this.form.title === this.$t('userManage.addUser')) {
                this.$refs.ruleForm.validate(valid => {
                  
                    if (valid && this.form.roleId) {
                        addObj(this.form.formItem).then(res => {
                            if (res.data.code === 200) {
                                this.$message.success(this.$t('userManage.addSuc'));
                                this.getUserData();
                            } else {
                                this.$message.error(this.$t('userManage.addFauRepeat'));
                                return;
                            }
                            this.handleClose();
                        });
                    } else {
                        this.$message.warning(this.$t('userManage.fillComplete'));
                        return;
                    }
                });
            } else {
                this.$refs.ruleForm.validate(valid => {
                     if (valid && this.form.roleId) {
                        putObj(this.form.formItem).then(res => {
                            if (res.data.code === 200) {
                                this.$message.success(this.$t('userManage.chaSuc'));
                                this.getUserData();
                            } else {
                                this.$message.error(this.$t('userManage.chaFauRepeat'));
                            }
                            this.handleClose();
                        });
                    } else {
                        this.$message.warning(this.$t('alarmSetting.fillComplete'));
                        return;
                    }
                });
            }
        },
        handleCancel(done) {
            this.form.formItem = {};
             this.isshow = false
            this.form.roleId = '';
         
            done();
        },
        handleClose() {
            this.form.formItem = {};
            this.isshow = false
            this.form.roleId = '';
            this.dialogFormVisible = false;
        },
        // 删除用户
        handleDel(index, row) {
            // 二次确认删除
            this.$confirm(this.$t('alarmSetting.promptContent')+"?", this.$t('alarmSetting.prompt'), {
                type: 'warning'
            })
                .then(() => {
                    delObj({ids:row.id}).then(res => {
                        if (res.data.code === 200) {
                            this.$message.success($t('alarmSetting.deleteSuc'));
                            if (index === 0) {
                                this.param.page.current -= 1;
                                this.getUserData();
                            }
                            this.tableData.splice(index, 1);
                            this.page.total -= 1;
                        } else {
                            this.$message.error($t('alarmSetting.deleteFau'));
                        }
                    });
                })
                .catch(() => {});
        },

        // 分电站表单
        handleStation(index, row) {
            console.log('row', row);
            this.station.title = this.$t('userManage.assignItem');
            this.$refs.stationModal.getUserStation(row);
            this.station.dialogStationVisible = true;
        },
        handleStationClose(num) {
            this.station.dialogStationVisible = false;
            if(num==='0'){
                this.getUserData()
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.containerManage{
  overflow-y: auto;
  box-sizing: border-box;
  width: calc(100% - 20px);
}
.page {
    float: right;
}

.stationForm {
    
        .el-tree {
            height: 500px;
            overflow: auto;
        }
    
}

</style>
